import _ from 'lodash';
import publicConfig from '../public-config';

/**
 * Returns `external_address` as a full origin URL.
 * - Empty (local dev): falls back to `window.location.origin`
 * - Bare hostname (e.g. `beta.peerspaceapp.com`): prepends `https://`
 * - Full URL (e.g. `https://beta.peerspaceapp.com`): used as-is
 *
 * Mirrors the normalization in `api/http-v2/buildUrl.js`.
 */
const getExternalAddress = () => {
  const url = publicConfig.external_address;
  if (!url) return typeof window !== 'undefined' ? window.location.origin : '';
  if (!/^https?:\/\//i.test(url)) return `https://${url}`;
  return url;
};
export { getExternalAddress };

const parseQueryString = function( queryString ) {
  var params = {}, queries, temp, i, l;
  // Split into key/value pairs
  queries = queryString.replace('?','').split("&");
  // Convert the array of strings into an object
  for ( i = 0, l = queries.length; i < l; i++ ) {
      temp = queries[i].split('=');
      params[temp[0]] = temp[1];
  }
  return params;
};
export { parseQueryString };

const getQueryString = function(searchKeys) {
  return _.reduce(searchKeys, function (str, val, key) {
    if (!val) {
      return str;
    } else if (str.length <= 0) {
      return key + '=' + val;
    } else {
      return str + '&' + key + '=' + val;
    }
  }, '');
};
export { getQueryString };
